/**
 * A unidade da Rede Inova. Uma só: por isso não existe seletor de unidade em lugar nenhum
 * (design 07), e as telas de acesso mostram este nome onde o design escreve a unidade.
 * Nunca o nome de outra farmácia.
 */
export const UNIDADE = 'Rede Inova · Muriaé';
